import flow from 'lodash/fp/flow';
import get from 'lodash/fp/get';

import { definitions, getConfig } from '@micro-apps/env';

const { STATIC_SITE_URL } = getConfig(process.env);

export const BOOKED = 'BOOKED';
export const PENDING_BOOKING = 'PENDING_BOOKING';
export const PENDING_MOD_BOOKING = 'PENDING_MOD_BOOKING';
export const NO_BOOKING = 'NO_BOOKING';

export function getBookingItineraryPath({
	locale,
	activeBooking,
	bookings,
	isSignedIn,
}: {
	locale: string;
	activeBooking?: definitions['booking'] | null;
	bookings: definitions['booking'][];
	isSignedIn: boolean;
}) {
	if (!activeBooking && bookings.length === 0) {
		return undefined;
	}

	if (!activeBooking && bookings.length > 1) {
		const path = [locale !== 'en' && locale, 'profile', 'my-stays'].filter(Boolean).join('/');
		return `${STATIC_SITE_URL || ''}/${path}`;
	}

	return flow(
		() => activeBooking || bookings[0],
		booking => {
			return {
				hotelCode: get(['hotelProducts', 0, 'hotelCode'])(booking),
				reservationId: get(['hotelProducts', 0, 'reservationId'])(booking),
			};
		},
		({ hotelCode, reservationId }) => {
			return hotelCode && reservationId
				? `${STATIC_SITE_URL || ''}/${[
						locale !== 'en' && locale,
						isSignedIn && 'profile',
						isSignedIn && 'my-stays',
						!isSignedIn && 'upcoming-trip',
						hotelCode,
						reservationId,
						'#itinerary',
					]
						.filter(Boolean)
						.join('/')}`
				: undefined;
		}
	)();
}
